import { useEffect, useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Tnews } from '../../../type/news';
import { postDataPages } from '../../../service/newsServise';
import { MINIO } from '../../../data/data';
import { Autoplay } from 'swiper/modules';
import { FiCalendar } from 'react-icons/fi';
import { Link } from 'react-router-dom';

const CarouselNews = () => {
    const [carouselList, setCarouselList] = useState<Tnews[]>([]);

    const getHeadlineNews = async () => {
        const data = {
            "pageNo": 0,
            "pageSize": 10,
            "sortType": "DESC",
            "filter": [
                {
                    "key": "headline",
                    "value": true,
                    "operation": "EQUAL",
                    "conjunction": "and"
                },
                {
                  key: 'active',
                  value: true,
                  operation: 'EQUAL',
                  conjunction: 'and',
                },
            ]
        }
        const response = await postDataPages(data);
        if (!response?.error) {
            setCarouselList(response?.data.content)
        }

    }

    useEffect(() => {
        getHeadlineNews()
    }, [])

    return (
        <>
            <Swiper
                slidesPerView={1}
                modules={[Autoplay]}
                centeredSlides={true}
                loop={true}
                autoplay={{
                    delay: 1000,
                    disableOnInteraction: false,
                }} >
                {carouselList.map((item: Tnews, index: number) => {
                    const text = item.content_plain || "";
                    const plain = text.substring(0, 100);
                    return (

                        <SwiperSlide key={index}>
                            <div className='bg-gray-50 text-center overflow-hidden h-[200px] rounded-sm'>
                                <Link to={`/admin/news/${item.slug}`}>
                                    <img src={`${MINIO}/${item.thumbnail}`} className='' alt={item.name} />
                                </Link>
                            </div>
                            <Link to={`/admin/news/${item.slug}`}>
                                <h2 className='text-[13px] font-medium mt-2'>{item.name}</h2>
                            </Link>
                            <span className='text-[10px] text-gray-400 m-0 p-0 flex items-center'>
                                <FiCalendar className='mr-2' />
                                {new Date(item.createDate).toLocaleDateString()} - {new Date(item.createDate).toLocaleTimeString()}
                            </span>
                            <p>{plain}</p>
                        </SwiperSlide>

                    )
                })}
            </Swiper>
        </>
    );
};

export default CarouselNews;